import * as React from 'react';
import * as I18n from 'i18n-js';
import ShopSettingsCreateVatIdForm from './shop_settings_create_vat_id_form';
import { ISelectOption } from '@reverbdotcom/commons/dist/components/form_group_with_select';
import { flashSuccess } from '@reverbdotcom/commons/dist/flash';

interface Props {
  countryOptions: ISelectOption[];
}

export default function ShopSettingsVatAddVatIdButton({ countryOptions }: Props) {
  const [isOpen, setIsOpen] = React.useState(false);

  function openForm() {
    setIsOpen(true);
  }

  function closeForm() {
    setIsOpen(false);
  }

  function closeFormAndFlashSuccess() {
    closeForm();
    flashSuccess(I18n.t('discovery.shopSettings.vat.saved'));
  }

  return (
    <>
      <button
        className="button button--blue"
        type="button"
        onClick={openForm}
      >
        {I18n.t('discovery.shopSettings.vat.addVat')}
      </button>
      <ShopSettingsCreateVatIdForm
        countryOptions={countryOptions}
        onComplete={closeFormAndFlashSuccess}
        isOpen={isOpen}
        closeForm={closeForm}
      />
    </>
  );
}



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/components/shop_settings_add_vat_id_button.tsx